export const languageMap = {
  en: 'en-US',
  ru: 'ru-RU',
  zh: 'zh-CN',
} as { [key: string]: string }
